import { useEffect } from "react";

/**
 * Schedules an automatic refetch when the server-side cache is about to expire.
 *
 * @param {Function} refetchFn - Function to call when the TTL elapses (e.g. RTK Query `refetch`).
 * @param {number|null|undefined} ttlSeconds - Seconds until the Redis cache expires.
 *   Pass null/undefined/0 to disable the timer (e.g. when cache is not in use).
 */
export function useCacheRefresh(refetchFn, ttlSeconds) {
    useEffect(() => {
        if (!ttlSeconds || ttlSeconds <= 0 || typeof refetchFn !== "function")
            return;

        console.log(`[useCacheRefresh] scheduling refetch in ${ttlSeconds}s`);
        const timerId = setTimeout(() => {
            refetchFn();
        }, ttlSeconds * 1000);

        return () => clearTimeout(timerId);
    }, [refetchFn, ttlSeconds]);
}
